export default __webpack_public_path__ + "static/media/star.e851d874.svg";